import { useNavigate } from "react-router-dom";
import { NewHeader } from "../../components/new-header";
import EmptyCan from "../../assets/empty can.png";

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className='td_new td_api_failed_page'>
      <div className='wrapper'>
        <NewHeader />
        <div className='body'>
          <h1>Oops! Looks like you took a wrong turn.</h1>
          <h3>
            The page you’re looking for isn’t here. <br />
            Maybe it moved, or maybe it never existed. <br />
            <br />
            No worries! You can:
          </h3>
          <button className='td-btn' onClick={() => navigate("/")}>
            <span>Go Home</span>
            <div className='chevron chevron-right' />
          </button>
          <img src={EmptyCan} alt='empty-can' className='img-fluid empty-can' />
        </div>
      </div>
    </div>
  );
}
